exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-2e429148] {\n  width: 100%;\n  border-collapse: collapse;\n}\ntable th[data-v-2e429148],\ntable td[data-v-2e429148] {\n  border: 1px solid black;\n  padding: 8px;\n  text-align: center;\n}\n", ""]);

// exports
